module.exports = __webpack_public_path__ + "static/media/1POLICY23.92fc7a66.jpg";